function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2413 3.51562C16.8343 2.48736 15.831 1.75781 14.6597 1.75781H14.4844V0H9.21094V1.75781H9.05701C7.88578 1.75781 6.88236 2.48736 6.47549 3.51562H2.00391V21.2109H0.304688V23.5561C0.304688 24.732 1.00166 25.7475 2.00391 26.213V30H21.6914V3.51562H17.2413ZM8.03906 4.53357C8.03906 3.9723 8.49568 3.51562 9.05701 3.51562H10.9688V1.75781H12.7266V3.51562H14.6597C15.221 3.51562 15.6776 3.9723 15.6776 4.53357V5.27344H8.03906V4.53357ZM16.3207 24.7266H3.23297C2.58756 24.7266 2.0625 24.2015 2.0625 23.5561V22.9688H16.125V23.7012C16.125 24.0631 16.1944 24.4091 16.3207 24.7266ZM3.76172 28.2422V26.4844H18.8682V26.4841C18.8815 26.4843 18.8948 26.4844 18.9082 26.4844C19.2703 26.4844 19.616 26.4141 19.9336 26.2878V28.2422H3.76172ZM19.9336 23.7012C19.9336 24.2665 19.4736 24.7266 18.9082 24.7266C18.3428 24.7266 17.8828 24.2665 17.8828 23.7012V21.2109H3.76172V5.27344H6.28125V7.03125H17.4354V5.27344H19.9336V23.7012Z",
  fill: "#23335B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9609 12.832H18.1758V14.5898H12.9609V12.832Z",
  fill: "#23335B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9609 9.31641H18.1758V11.0742H12.9609V9.31641Z",
  fill: "#23335B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.57812 16.3477H10.8516V18.1055H5.57812V16.3477Z",
  fill: "#23335B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9609 16.3477H18.1758V18.1055H12.9609V16.3477Z",
  fill: "#23335B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.09375 9.31641H7.33594V11.0742H5.57812V12.832H7.33594V14.5898H9.09375V12.832H10.8516V11.0742H9.09375V9.31641Z",
  fill: "#23335B"
});

var SvgPrescriptionHistory = function SvgPrescriptionHistory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 22 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrescriptionHistory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/prescription-history.5676d0d5.svg";
export { ForwardRef as ReactComponent };